import { render } from "./gf2satinfo.vue?vue&type=template&id=2197fa80&scoped=true"
const script = {}

import "./gf2satinfo.vue?vue&type=style&index=0&id=2197fa80&scoped=true&lang=css"

import exportComponent from "E:\\lb\\vue30\\tuiguang_meng\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2197fa80"]])

export default __exports__